/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/main.js":
/*!************************!*\
  !*** ./src/js/main.js ***!
  \************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/**
 * SizeGuideHandler Custom Element
 * A web component that handles opening the size guide modal
 * Can be used anywhere in the page to trigger the size guide
 */
var SizeGuideHandler = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SizeGuideHandler, _HTMLElement);
  var _super = _createSuper(SizeGuideHandler);
  function SizeGuideHandler() {
    _classCallCheck(this, SizeGuideHandler);
    return _super.call(this);
  }

  /**
   * Lifecycle callback when element is added to the DOM
   * Sets up event listener for opening size guide
   */
  _createClass(SizeGuideHandler, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.addEventListener('click', function (e) {
        e.preventDefault();
        _this.openSizeGuide();
      });
    }

    /**
     * Opens the size guide modal
     * Finds the size-guide element and triggers its open state
     */
  }, {
    key: "openSizeGuide",
    value: function openSizeGuide() {
      var sizeGuide = document.querySelector('size-guide');
      if (sizeGuide) {
        sizeGuide.classList.remove('size-guide--closed');
        sizeGuide.classList.add('size-guide--open');
        sizeGuide.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
    }
  }]);
  return SizeGuideHandler;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define('size-guide-handler', SizeGuideHandler);

/**
 * SizeGuide Custom Element
 * A web component that handles the size guide functionality for jewelry items
 * including chains, bracelets, and rings. It manages the display of size guides
 * and handles user interactions for selecting different sizes.
 */
var SizeGuide = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(SizeGuide, _HTMLElement2);
  var _super2 = _createSuper(SizeGuide);
  function SizeGuide() {
    var _this2;
    _classCallCheck(this, SizeGuide);
    _this2 = _super2.call(this);

    // Main size guide elements
    // this.sizeGuideLink = document.querySelector('.size-guide-link');
    _this2.sizeGuideClose = _this2.querySelector('.size-guide__content-close');
    _this2.sizeGuideOverlay = _this2.querySelector('.size-guide__overlay');

    // Unit toggle elements
    _this2.unitToggle = _this2.querySelector('.unit-toggle-switch');
    _this2.currentUnit = 'inch'; // default unit

    // Chain-specific elements
    _this2.chainButtons = _this2.querySelectorAll('.chain-size-guide__button');
    _this2.chainImages = _this2.querySelectorAll('.chain-size-guide__image');
    _this2.selectedLength = _this2.querySelector('.chain-size-guide__selected-length');
    _this2.selectedNeck = _this2.querySelector('.chain-size-guide__selected-neck');

    // Bracelet-specific elements
    _this2.braceletButtons = _this2.querySelectorAll('.bracelet-size-guide__button');
    _this2.braceletTabs = _this2.querySelectorAll('.bracelet-tab');

    // Ring-specific elements
    _this2.ringButtons = _this2.querySelectorAll('.ring-size-guide__button');
    _this2.ringTabs = _this2.querySelectorAll('.ring-tab');

    // Pendant-specific elements
    _this2.pendantButtons = _this2.querySelectorAll('.pendant-size-guide__button');
    _this2.pendantTabs = _this2.querySelectorAll('.pendant-tab');

    // Ring size guide select elements
    _this2.sizeGuideSelect = _this2.querySelector('[data-size-guide-no-option-select]');
    _this2.sizeGuideOption1 = _this2.querySelector('[data-size-guide-no-option-1]');
    _this2.sizeGuideOption2 = _this2.querySelector('[data-size-guide-no-option-2]');
    _this2.sizeGuideLabel1 = _this2.querySelector('[data-size-guide-no-label-1]');
    _this2.sizeGuideLabel2 = _this2.querySelector('[data-size-guide-no-label-2]');
    return _this2;
  }

  /**
   * Lifecycle callback when element is added to the DOM
   * Sets up event listeners for all interactive elements
   */
  _createClass(SizeGuide, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initializeUnitDisplay();
      this.attachEvents();
    }

    /**
     * Initializes the unit display to show inches by default
     */
  }, {
    key: "initializeUnitDisplay",
    value: function initializeUnitDisplay() {
      // Set toggle to active state for inches
      if (this.unitToggle) {
        this.unitToggle.classList.add('active');
      }

      // Update all chain length buttons to show inches
      this.chainButtons.forEach(function (button) {
        if (button.getAttribute('data-type') === 'length') {
          var sizeInch = button.getAttribute('data-size-inch');
          if (sizeInch) {
            button.textContent = sizeInch + '"';
          }
        }
      });

      // Update selected length display if it exists
      if (this.selectedLength) {
        var selectedButton = this.querySelector('.chain-size-guide__length-buttons .chain-size-guide__button[aria-selected="true"]');
        if (selectedButton) {
          var sizeInch = selectedButton.getAttribute('data-size-inch');
          if (sizeInch) {
            this.selectedLength.textContent = sizeInch;
          }
        }
      }
    }

    /**
     * Attaches event listeners to all interactive elements
     * Handles opening/closing of size guide and size selection for different jewelry types
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      // Close size guide when close button is clicked
      this.sizeGuideClose.addEventListener('click', function () {
        _this3.closeSizeGuide();
      });

      // Close size guide when overlay is clicked
      this.sizeGuideOverlay.addEventListener('click', function () {
        _this3.closeSizeGuide();
      });

      // Handle chain size selection
      this.chainButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.handleChainButtonClick(button);
        });
      });

      // Handle bracelet size selection
      this.braceletButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.handleBraceletButtonClick(button);
        });
      });

      // Handle ring size selection
      this.ringButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.handleRingButtonClick(button);
        });
      });

      // Handle pendant size selection
      this.pendantButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          _this3.handlePendantButtonClick(button);
        });
      });

      // Handle size guide option select change
      if (this.sizeGuideSelect) {
        this.sizeGuideSelect.addEventListener('change', function (e) {
          _this3.handleSizeGuideSelectChange(e.target.value);
        });
      }

      // Handle unit toggle
      if (this.unitToggle) {
        this.unitToggle.addEventListener('click', function () {
          _this3.handleUnitToggle();
        });
      }
    }

    /**
     * Closes the size guide modal
     * Resets ARIA attributes and restores body scrolling
     */
  }, {
    key: "closeSizeGuide",
    value: function closeSizeGuide() {
      this.classList.remove('size-guide--open');
      this.classList.add('size-guide--closed');
      this.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = 'auto';
    }

    /**
     * Handles chain size button clicks
     * Updates selected length and neck size, and shows corresponding chain image
     * @param {HTMLElement} button - The clicked chain size button
     */
  }, {
    key: "handleChainButtonClick",
    value: function handleChainButtonClick(button) {
      var length, neck;
      if (button.getAttribute('data-type') === 'length') {
        length = button.getAttribute('data-size');
        neck = this.querySelector('.chain-size-guide__neck-buttons .chain-size-guide__button[aria-selected="true"]').getAttribute('data-size');
        this.querySelector('.chain-size-guide__length-buttons .chain-size-guide__button[aria-selected="true"]').setAttribute('aria-selected', 'false');
        button.setAttribute('aria-selected', 'true');
        if (this.selectedLength) {
          this.selectedLength.textContent = length;
        }
      } else {
        neck = button.getAttribute('data-size');
        length = this.querySelector('.chain-size-guide__length-buttons .chain-size-guide__button[aria-selected="true"]').getAttribute('data-size');
        this.querySelector('.chain-size-guide__neck-buttons .chain-size-guide__button[aria-selected="true"]').setAttribute('aria-selected', 'false');
        button.setAttribute('aria-selected', 'true');
        if (this.selectedNeck) {
          this.selectedNeck.textContent = neck;
        }
      }
      var image = this.querySelector(".chain-size-guide__image[data-length=\"".concat(length, "\"][data-neck=\"").concat(neck, "\"]"));
      this.querySelector('.chain-size-guide__image[aria-hidden="false"]').setAttribute('aria-hidden', 'true');
      image.setAttribute('aria-hidden', 'false');
    }

    /**
     * Handles bracelet size button clicks
     * Updates selected bracelet size and shows corresponding size guide tab
     * @param {HTMLElement} button - The clicked bracelet size button
     */
  }, {
    key: "handleBraceletButtonClick",
    value: function handleBraceletButtonClick(button) {
      var target = button.getAttribute('data-target');
      this.braceletTabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', 'false');
      });
      this.querySelector('.bracelet-size-guide__button[aria-selected="true"]').setAttribute('aria-selected', 'false');
      button.setAttribute('aria-selected', 'true');
      this.querySelector("#".concat(target)).setAttribute('aria-selected', 'true');
    }

    /**
     * Handles ring size button clicks
     * Updates selected ring size and shows corresponding size guide tab
     * @param {HTMLElement} button - The clicked ring size button
     */
  }, {
    key: "handleRingButtonClick",
    value: function handleRingButtonClick(button) {
      var target = button.getAttribute('data-target');
      this.ringTabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', 'false');
      });
      this.querySelector('.ring-size-guide__button[aria-selected="true"]').setAttribute('aria-selected', 'false');
      button.setAttribute('aria-selected', 'true');
      this.querySelector("#".concat(target)).setAttribute('aria-selected', 'true');
    }

    /**
     * Handles pendant size button clicks
     * Updates selected pendant size and shows corresponding size guide tab
     * @param {HTMLElement} button - The clicked pendant size button
     */
  }, {
    key: "handlePendantButtonClick",
    value: function handlePendantButtonClick(button) {
      var target = button.getAttribute('data-target');
      this.pendantTabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', 'false');
      });
      this.querySelector('.pendant-size-guide__button[aria-selected="true"]').setAttribute('aria-selected', 'false');
      button.setAttribute('aria-selected', 'true');
      this.querySelector("#".concat(target)).setAttribute('aria-selected', 'true');
    }

    /**
     * Handles unit toggle between cm and inch
     * Updates button displays and toggle state
     */
  }, {
    key: "handleUnitToggle",
    value: function handleUnitToggle() {
      var _this4 = this;
      // Toggle unit
      this.currentUnit = this.currentUnit === 'cm' ? 'inch' : 'cm';

      // Update toggle button state
      this.unitToggle.classList.toggle('active');

      // Update all chain length buttons
      this.chainButtons.forEach(function (button) {
        if (button.getAttribute('data-type') === 'length') {
          var sizeInch = button.getAttribute('data-size-inch');
          var sizeCm = button.getAttribute('data-size');
          button.textContent = _this4.currentUnit === 'inch' ? sizeInch + '"' : sizeCm;
        }
      });

      // Update selected length display if it exists
      if (this.selectedLength) {
        var selectedButton = this.querySelector('.chain-size-guide__length-buttons .chain-size-guide__button[aria-selected="true"]');
        if (selectedButton) {
          var sizeInch = selectedButton.getAttribute('data-size-inch');
          var sizeCm = selectedButton.getAttribute('data-size');
          this.selectedLength.textContent = this.currentUnit === 'inch' ? sizeInch : sizeCm;
        }
      }
    }

    /**
     * Handles size guide select change
     * Toggles visibility of option sections based on select value
     * @param {string} value - The selected option value
     */
  }, {
    key: "handleSizeGuideSelectChange",
    value: function handleSizeGuideSelectChange(value) {
      if (value === 'option-1') {
        // Show option 1, hide option 2
        if (this.sizeGuideOption1) {
          this.sizeGuideOption1.classList.remove('hidden');
        }
        if (this.sizeGuideOption2) {
          this.sizeGuideOption2.classList.add('hidden');
        }
        if (this.sizeGuideLabel1) {
          this.sizeGuideLabel1.classList.remove('hidden');
        }
        if (this.sizeGuideLabel2) {
          this.sizeGuideLabel2.classList.add('hidden');
        }
      } else if (value === 'option-2') {
        // Show option 2, hide option 1
        if (this.sizeGuideOption1) {
          this.sizeGuideOption1.classList.add('hidden');
        }
        if (this.sizeGuideOption2) {
          this.sizeGuideOption2.classList.remove('hidden');
        }
        if (this.sizeGuideLabel1) {
          this.sizeGuideLabel1.classList.add('hidden');
        }
        if (this.sizeGuideLabel2) {
          this.sizeGuideLabel2.classList.remove('hidden');
        }
      }
    }
  }]);
  return SizeGuide;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register the custom element
customElements.define('size-guide', SizeGuide);

/***/ }),

/***/ "./src/scss/sr-custom.scss":
/*!*********************************!*\
  !*** ./src/scss/sr-custom.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/main": 0,
/******/ 			"assets/sr-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgrayl"] = self["webpackChunkgrayl"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/js/main.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/sr-custom"], () => (__webpack_require__("./src/scss/sr-custom.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;